import type { ProfileResponse } from '@thrivehrm/shared';

export const PROFILE_TABS = [
  'overview',
  'personal',
  'employment',
  'salary',
  'bank',
  'contact',
  'emergency',
  'history',
  'payslips',
  'security',
] as const;
export type ProfileTab = (typeof PROFILE_TABS)[number];

export const TAB_LABELS: Readonly<Record<ProfileTab, string>> = {
  overview: 'Overview',
  personal: 'Personal',
  employment: 'Employment',
  salary: 'Salary',
  bank: 'Bank & TIN',
  contact: 'Contact',
  emergency: 'Emergency',
  history: 'History',
  payslips: 'Payslips',
  security: 'Security',
};

/**
 * Tabs this viewer gets (FR-EMP-7): Salary only per AC-3, Bank & TIN only per AC-6 — taken from
 * the API's `access` flags, never decided here. History (T-029) is for everyone who may see the profile; the API leaves out salary and Bank & TIN entries. Documents (T-032) follow.
 */
export function visibleTabs(access: ProfileResponse['access']): ProfileTab[] {
  return PROFILE_TABS.filter(
    (t) =>
      (t !== 'salary' || access.salary) &&
      (t !== 'bank' || access.sensitive) &&
      // Payslips (FR-PAY-18): one's own, on My profile only.
      (t !== 'payslips' || access.self) &&
      // Security (FR-AUTH-18, T-13B): change one's own password, on My profile only.
      (t !== 'security' || access.self),
  );
}

/**
 * What the API withheld from this viewer (T-106, `A02-profile-branch-manager` design), named from
 * the `access` flags only — never from roles. Nothing for one's own profile.
 */
export function hiddenSections(access: ProfileResponse['access']): string[] {
  if (access.self) return [];
  return [
    ...(access.salary ? [] : ['Salary']),
    ...(access.sensitive ? [] : ['Bank & TIN', 'identity numbers', 'documents']),
  ];
}
